import React from 'react';

export default function PageHeader({ title, subtitle, right }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
      <div>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-slate-900">{title}</h1>
        {subtitle && <p className="text-slate-500 mt-1.5">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}
